// extracted by mini-css-extract-plugin
export default {"button":"Ro-z","reviewSort":"So-z"};